import React from "react";
import _ from "lodash";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import { PureAppComponent } from "../../../Components/AppComponent";
import RenderAmount from "../../../Components/etc/RenderAmount";
import { getFullName } from "../../../Modules/utils/fullname";
import { getPhoneNumber } from "../../../Modules/utils/phoneno";

const SCREEN_NAME = "TRANSACTION_DETAILS_SCREEN";

class TransactionDetailsInner extends PureAppComponent {
  state = {
    loading: false,
    error: null,
  };

  columns = [
    { value: "_id", label: "ID" },
    {
      value: "t",
      label: "Time",
      render: ({ item }) => new Date(item.t).toLocaleString(),
    },
    {
      value: "amount",
      label: "Amount",
      render: ({ item }) => (
        <RenderAmount style={{ textAlign: "left" }} value={item.amount} />
      ),
    },
    {
      value: "side",
      label: "Transaction Side",
    },
    {
      value: "transactionType",
      label: "Transaction Type",
      render: ({ item }) => _.startCase(item.transactionType),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => <div className="multiline">{item.note}</div>,
    },
    {
      value: "collector",
      label: "Collector",
      render: ({ item }) => getFullName(item.collector),
    },
    {
      value: "collectorCommission",
      label: "Collector Commission (%)",
    },
    {
      value: "account",
      label: "Account",
      render: ({ item }) => {
        const account = item.account;
        return (
          <Table striped bordered hover size="sm" className="vertical-table">
            <tbody>
              <tr>
                <th>ID</th>
                <td>{account.shortId}</td>
              </tr>
              <tr>
                <th>Interest Rate (%)</th>
                <td>{account?.interestRate}</td>
              </tr>
            </tbody>
          </Table>
        );
      },
    },

    {
      value: "customer",
      label: "Customer",
      render: ({ item }) => {
        const customer = item.customer;
        return (
          <Table striped bordered hover size="sm" className="vertical-table">
            <tbody>
              <tr>
                <th>Name</th>
                <td>{getFullName(customer)}</td>
              </tr>
              <tr>
                <th>Phone</th>
                <td>{getPhoneNumber(customer).formated}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{customer.email}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td className="multiline">{customer.address}</td>
              </tr>
            </tbody>
          </Table>
        );
      },
    },
  ];

  renderTable(item) {
    return (
      <div className="tablewrapper">
        <Table className="vertical-table" striped hover bordered>
          <tbody>
            {this.columns.map((col) => (
              <tr key={col.value}>
                <th>{col.label}</th>
                <td>{col.render ? col.render({ item }) : item[col.value]}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  renderInner() {
    const {
      state: { loading, error },
      props: { transaction },
    } = this;

    return (
      <div className="account-details">
        {loading ? <center>Loading...</center> : null}
        {error ? <div className="errormsg">{error}</div> : null}
        {this.renderTable(transaction)}
      </div>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: `Transaction Details`,
          showFooter: false,
        }}
      >
        {this.renderInner()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false, transaction },
    } = this;

    if (!transaction) return null;
    else if (renderModal) return this.renderModal();
    else return this.renderInner();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const TransactionDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionDetailsInner);

export default TransactionDetails;
